import { IHoliday } from "../holidayTypes";

export const SwedenHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Nyårsdagen", type: "HOLIDAY" },
  "2024-01-06": { title: "Trettondedag jul", type: "HOLIDAY" },
  "2024-03-29": { title: "Långfredagen", type: "HOLIDAY" },
  "2024-03-31": { title: "Påskdagen", type: "HOLIDAY" },
  "2024-04-01": { title: "Annandag påsk", type: "HOLIDAY" },
  "2024-05-01": { title: "Första maj", type: "HOLIDAY" },
  "2024-05-09": { title: "Kristi himmelsfärdsdag", type: "HOLIDAY" },
  "2024-05-19": { title: "Pingstdagen", type: "HOLIDAY" },
  "2024-06-06": { title: "Sveriges nationaldag", type: "HOLIDAY" },
  "2024-06-22": { title: "Midsommardagen", type: "HOLIDAY" },
  "2024-10-31": { title: "Halloween", "type": "SPECIAL_DAY" },
  "2024-11-02": { title: "Alla helgons dag", type: "HOLIDAY" },
  "2024-12-13": { title: "Lucia", "type": "SPECIAL_DAY" },
  "2024-12-24": { title: "Julafton", type: "SPECIAL_DAY" },
  "2024-12-25": { title: "Juldagen", type: "HOLIDAY" },
  "2024-12-26": { title: "Annandag jul", type: "HOLIDAY" },
  "2024-12-31": { title: "Nyårsafton", type: "SPECIAL_DAY" },

  // 2025
  "2025-01-01": { title: "Nyårsdagen", type: "HOLIDAY" },
  "2025-01-05": { title: "Trettondagsafton", type: "SPECIAL_DAY" },
  "2025-01-06": { title: "Trettondedag jul", type: "HOLIDAY" },
  "2025-04-17": { title: "Skärtorsdagen", type: "SPECIAL_DAY" },
  "2025-04-18": { title: "Långfredagen", type: "HOLIDAY" },
  "2025-04-20": { title: "Påskdagen", type: "HOLIDAY" },
  "2025-04-19": { title: "Påskafton", type: "SPECIAL_DAY" },
  "2025-04-21": { title: "Annandag påsk", type: "HOLIDAY" },
  "2025-04-30": { title: "Valborgsmässoafton", type: "SPECIAL_DAY" },
  "2025-05-01": { title: "Första maj", type: "HOLIDAY" },
  "2025-05-29": { title: "Kristi himmelsfärdsdag", type: "HOLIDAY" },
  "2025-06-06": { title: "Sveriges nationaldag", type: "HOLIDAY" },
  "2025-06-20": { title: "Midsommarafton", type: "SPECIAL_DAY" },
  "2025-06-21": { title: "Midsommardagen", type: "HOLIDAY" },
  "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2025-11-01": { title: "Alla helgons dag", type: "HOLIDAY" },
  "2025-12-13": { title: "Lucia", type: "SPECIAL_DAY" },
  "2025-12-24": { title: "Julafton", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Juldagen", type: "HOLIDAY" },
  "2025-12-26": { title: "Annandag jul", type: "HOLIDAY" },
  "2025-12-31": { title: "Nyårsafton", type: "SPECIAL_DAY" },


  // 2026
  "2026-01-01": { title: "Nyårsdagen", type: "HOLIDAY" },
  "2026-01-05": { title: "Trettondagsafton", type: "SPECIAL_DAY" },
  "2026-01-06": { title: "Trettondedag jul", type: "HOLIDAY" },
  "2026-04-02": { title: "Skärtorsdagen", type: "SPECIAL_DAY" },
  "2026-04-03": { title: "Långfredagen", type: "HOLIDAY" },
  "2026-04-04": { title: "Påskafton", type: "SPECIAL_DAY" },
  "2026-04-05": { title: "Påskdagen", type: "HOLIDAY" },
  "2026-04-06": { title: "Annandag påsk", type: "HOLIDAY" },
  "2026-04-30": { title: "Valborgsmässoafton", type: "SPECIAL_DAY" },
  "2026-05-01": { title: "Första maj", type: "HOLIDAY" },
  "2026-05-14": { title: "Kristi himmelsfärdsdag", type: "HOLIDAY" },
  "2026-06-06": { title: "Sveriges nationaldag", type: "HOLIDAY" },
  "2026-06-19": { title: "Midsommarafton", type: "SPECIAL_DAY" },
  "2026-06-20": { title: "Midsommardagen", type: "HOLIDAY" },
  "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2026-11-01": { title: "Alla helgons dag", type: "HOLIDAY" },
  "2026-12-13": { title: "Lucia", type: "SPECIAL_DAY" },
  "2026-12-24": { title: "Julafton", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Juldagen", type: "HOLIDAY" },
  "2026-12-26": { title: "Annandag jul", type: "HOLIDAY" },
  "2026-12-31": { title: "Nyårsafton", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Nyårsdagen", type: "HOLIDAY" },
  "2027-01-05": { title: "Trettondagsafton", type: "SPECIAL_DAY" },
  "2027-01-06": { title: "Trettondedag jul", type: "HOLIDAY" },
  "2027-03-25": { title: "Skärtorsdagen", type: "SPECIAL_DAY" },
  "2027-03-26": { title: "Långfredagen", type: "HOLIDAY" },
  "2027-03-27": { title: "Påskafton", type: "SPECIAL_DAY" },
  "2027-03-28": { title: "Påskdagen", type: "HOLIDAY" },
  "2027-03-29": { title: "Annandag påsk", type: "HOLIDAY" },
  "2027-04-30": { title: "Valborgsmässoafton", type: "SPECIAL_DAY" },
  "2027-05-01": { title: "Första maj", type: "HOLIDAY" },
  "2027-05-06": { title: "Kristi himmelsfärdsdag", type: "HOLIDAY" },
  "2027-06-06": { title: "Sveriges nationaldag", type: "HOLIDAY" },
  "2027-06-25": { title: "Midsommarafton", type: "SPECIAL_DAY" },
  "2027-06-26": { title: "Midsommardagen", type: "HOLIDAY" },
  "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2027-11-06": { title: "Alla helgons dag", type: "HOLIDAY" },
  "2027-12-13": { title: "Lucia", type: "SPECIAL_DAY" },
  "2027-12-24": { title: "Julafton", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Juldagen", type: "HOLIDAY" },
  "2027-12-26": { title: "Annandag jul", type: "HOLIDAY" },
  "2027-12-31": { title: "Nyårsafton", type: "SPECIAL_DAY" }
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/swedenHolidays.ts